export const BOTTOM_NAVBAR_DEFAULT_HEIGHT = "70px";
export const BOTTOM_NAVBAR_IOS_APP_HEIGHT = "90px";
